export const number = {
  type: {
    local: 'Lokal',
    mobile: 'Telepon seluler',
    national: 'Nasional',
    toll_free: 'Toll free'
  },

  status: {
    stand_by: 'Tidak aktif',
    active: 'Aktif',
    deactivated: 'Dinonaktifkan',
    canceled: 'Batalkan',
    on_deactivation: 'Pada penonaktifan'
  },

  is_spam: {
    yes: 'Spam',
    no: 'Check'
  },

  state: {
    direction_to_pbx_error: 'PBX referral error',
    direction_to_pbx_pending: 'Kirim ke PBX',
    direction_to_pbx_success: 'Tujuan ke PBX',
    direction_to_number_verification: 'Verifikasi dikirim'
  },

  computed_confirmation_type: {
    support: 'Kontak dukungan',
    required_documents: 'Dokumen dibutuhkan',
    need_verification: 'Dokumen dalam moderasi',
    allow_buying: 'Cadangan'
  },

  field: {
    number: 'Nomor',
    country: 'Negara',
    region: 'Area',
    type: 'Jenis',
    purchased_at: 'Beli pada',
    activated_at: 'Aktivasi ulang pada',
    is_spam: 'Spam',
    destinations: 'Tujuan',
    connection_cost: 'Biaya koneksi',
    subscription_fee: 'Biaya berlangganan',
    minutes_cost: 'Biaya per menit',
    allow_sms: 'SMS',
    state: 'Dipergunakan',
    deactivated_at: 'Aktifasi ulang pada',
    capabilities: 'Kapabilitas',
    current_status: 'Status saat ini',
  },

  action: {
    deactivate: 'Aktifasi ulang',
    connect_pbx: 'Kirim ke PBX',
    stats: 'Statistik'
  },

  modal: {
    deactivate: {
      content: 'Apakah Anda yakin ingin aktifasi ulang nomor telepon {number}?'
    },

    connect_pbx: {
      content:
        '<p>Anda yakin ingin mengirim nomor telepon {number} ke PBX? </p> Setelah terkoneksi, nomor tersebut akan tersedia dalam beberapa jam.'
    },

    buy: {
      content:
        '<p>Anda yakin ingin memesan nomor telepon {number}?<br> Biaya koneksi - {connection_cost}, <br> Biaya berlangganan - {subscription_fee}.</p>'
    },

    required_documents: {
      content: '<p>Unggah dokumen untuk membeli {number} nomor telepon.</p>'
    },

    add_custom: {
      title: 'Tambahkan Nomor Anda',
      field: {
        code: {
          title: 'Kode'
        }
      },
      button: {
        send: 'Kirim',
        check: 'Periksa',
        save: 'Simpan'
      },
      error: {
        duplicate: 'Nomor sudah ada sebelumnya'
      }
    }
  },

  days_until_payment:
    '0 hari sebelum pembayaran | {hitung} hari sebelum pembayaran | {hitung} hari sebelum pembayaran',

  badge: {
    total_active: 'Nomor Aktif',
    total: 'Total Nomor',
    fee: 'Biaya Langganan'
  },
  tooltips: {
    fee:
      "Total biaya langganan untuk semua nomor aktif saat ini.",
    all_number_period:
      'Termasuk nomor dalam status apa pun, yang tanggal aktivasi nya tidak lebih lambat dari akhir periode.',
    cost_period:
      'Total semua transaksi pembayaran biaya langganan, tanggal nya masuk dalam rentang periode',
    average_period: 'Total pembayaran biaya langganan, dibagi dengan jumlah pemotongan.'
  }
};
